<template>

    <Head>
        <meta name="title" content="TV Series and Movies Vocabulary - 5000 Frequently Used Words" />
        <title>TV Series and Movies Vocabulary - 5000 Frequently Used Words</title>
        <meta name="description"
            content="For those who want to learn English with TV series, we have determined the 5000 most frequently used words in English TV series." />
    </Head>
    <div class="container pt-5 mt-5 pb-3">

        <div class="row mx-auto">
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
            <div class="col-12 col-md-8 mx-auto">
                <h1 class="archivo">TV Series and Movies Vocabulary - 5000 Frequently Used Words</h1>

                <p>Learning the most commonly used English words has many advantages. It can open new doors in your
                    professional or academic life. Once you learn these words, you'll be able to understand tv series
                    and
                    movies comfortably with or without English subtitles. Additionally, as the following list contains
                    words most frequently used in everyday language, learning these words will also improve your English
                    speaking skills. We've analyzed approximately 60 series and 60 movies, identifying the 5000
                    most commonly used English words. We even found the meanings for each of them! To go further, we've
                    prepared quizzes where you can practice these words :) Now, let’s take a look at the 5000 word list:
                </p>

                <div v-if="false" class="ad-container-yatay">
                    <Adsense data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990" data-ad-format="auto"
                        :data-full-width-responsive="true">
                    </Adsense>
                </div>

                <div class="row mt-5">
                    <WordListComponent v-if="isReady" :wordList="wordListData.words" :sliderValueArg="[1, 9]">
                    </WordListComponent>
                    <Loading style="" v-else />
                </div>
                <div v-if="list_index < 5" class="row mt-5 mx-auto">
                    <div class="col-4 mx-auto">
                        <button @click="load_words()" class="medium-purple-button">More</button>
                    </div>
                </div>
            </div>
            <div v-if="false" class="col-md-2 col-12 ad-container-200">
                <Adsense class="sticky-element" data-ad-client="ca-pub-3579545649702539" data-ad-slot="2552267990"
                    data-ad-format="auto" :data-full-width-responsive="true">
                </Adsense>
            </div>
        </div>
        <SuggestedBlogs></SuggestedBlogs>

    </div>
</template>
<script>
import axios from "axios"
import WordListComponent from "../../../components/Shared/WordListComponent.vue";
import SuggestedBlogs from "../../../components/Shared/SuggestedBlogs.vue";
export default {
    data() {
        return {
            wordListData: {},
            isReady: false,
            list_index: 1,
            list_ids: [943, 945, 946, 947, 948]
        };
    },
    components: {
        WordListComponent,
        SuggestedBlogs
    },
    created() {
        this.$store.commit('setEditOption', false)

        axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: 943, MeanLanguageType: 1 } }).then((response) => {
            this.wordListData = response.data

        }).finally(() => {
            this.isReady = true
        }).catch(error => {
            console.log(error.response.data)
        })
    },
    methods: {
        load_words() {
            if (this.list_index < 5) {
                axios.get('/api/WordList/GetWordListV2', { params: { type: 5, id: this.list_ids[this.list_index], MeanLanguageType: 1 } }).then((response) => {
                    let words = response.data.words
                    this.wordListData.words.push(...words)
                }).finally(() => {
                    this.isReady = true
                    this.list_index += 1
                }).catch(error => {
                    console.log(error.response.data)
                })
            }
        }
    },
}

</script>